import { render, staticRenderFns } from "./gtr-loader.vue?vue&type=template&id=4a0d6fde&scoped=true"
import script from "./gtr-loader.ts?vue&type=script&lang=ts&external"
export * from "./gtr-loader.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-loader.vue?vue&type=style&index=0&id=4a0d6fde&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d6fde",
  null
  
)

export default component.exports